import styled from '@emotion/styled';

export const Layout = styled.div`  
  position: relative;
  width: 100%;
`;

export const Content = styled.main<{ navHeight: number, inExtension:boolean }>`
  position: relative;
  width: 100%;
  --regi-nav-height: ${({ navHeight }) => navHeight}px;
  margin-top: ${props => props.inExtension?"0px": `calc(${props.theme.layout.headerHeight}px + var(--regi-nav-height))`} ;
  overflow: hidden;
  min-height: calc(var(--site-height) - var(--header-height) - var(--regi-nav-height));
  height:100%;
`;
